/**
 * @generated SignedSource<<43af61a56368cc1cf0f9ae23f26306a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteVSTSAccountInput = {
  vstsAccount?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteVstsAccountMutation$variables = {
  input: DeleteVSTSAccountInput;
};
export type deleteVstsAccountMutation$data = {
  readonly deleteVSTSAccount: {
    readonly viewer: {
      readonly company: {
        readonly vstsEnabled: boolean | null;
        readonly vstsAccount: ReadonlyArray<string | null> | null;
        readonly vstsEstimateField: string | null;
      } | null;
    } | null;
  } | null;
};
export type deleteVstsAccountMutation = {
  variables: deleteVstsAccountMutation$variables;
  response: deleteVstsAccountMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEstimateField",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteVstsAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVSTSAccountPayload",
        "kind": "LinkedField",
        "name": "deleteVSTSAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteVstsAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVSTSAccountPayload",
        "kind": "LinkedField",
        "name": "deleteVSTSAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92bd99f6abbf8ab9fe1781b7e2d7f53f",
    "id": null,
    "metadata": {},
    "name": "deleteVstsAccountMutation",
    "operationKind": "mutation",
    "text": "mutation deleteVstsAccountMutation(\n  $input: DeleteVSTSAccountInput!\n) {\n  deleteVSTSAccount(input: $input) {\n    viewer {\n      company {\n        vstsEnabled\n        vstsAccount\n        vstsEstimateField\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a1a0ea885de4f422fcbf60c5ee1bfd8";

export default node;
